import ColumnBase from "./ColumnBase.jsx";
import { WIDGET_KEYS } from "../../other/constants/WidgetKeys.jsx";
import { ColumnStore,  } from "@bryntum/schedulerpro";
import { EntityMainNameDefault } from "../../other/utils/utils.jsx";

export default class IncentiveRolePermissionColumn extends ColumnBase {
  static get $name() {
    return "IncentiveRolePermissionColumn"
  }

  static get type() {
    return WIDGET_KEYS.incentiveRolePermissionColumn;
  }

  static get defaults() {
    return {
      editor: false,
      flex: 1,
    }
  }

  renderer({ record }) {
    return EntityMainNameDefault({ text: this.getSelectedRoleRecord(record)?.name })
  }

  onLoad(project) {
    this.project = project;
  }

  get canEmptySwivuList() {
    return false;
  }

  get swivuListTitle() {
    return "Role"
  }

  get swivuListItems() {
    /* Exclude deactivated role */
    return this.project.swivuAppRoles.filter((role) => role.id !== 7);
  }

  getSwivuListItemDisplayValue(roleRecord) {
    return roleRecord.name;
  }

  getSelectedSwivuListItem(record) {
    return this.getSelectedRoleRecord(record);
  }

  onSwivuListSelectionChange(record, [roleRecord]) {
    record[this.field] = roleRecord.id;
  }

  getSelectedRoleRecord(rowRecord) {
    return this.swivuListItems.find((role) => role.id === rowRecord[this.field]);
  }
}

ColumnStore.registerColumnType(IncentiveRolePermissionColumn);
